import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Information */}
        <div className="footer-section">
          <h3>{t('footer.company.title')}</h3>
          <p>{t('footer.company.description')}</p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>{t('footer.quickLinks.title')}</h3>
          <ul>
            <li><a href="#about">{t('nav.about')}</a></li>
            <li><a href="#services">{t('nav.services')}</a></li>
            <li><a href="#gallery">{t('nav.gallery')}</a></li>
            <li><a href="#testimonials">{t('nav.testimonials')}</a></li>
            <li><a href="#contact">{t('nav.contact')}</a></li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="footer-section">
          <h3>{t('footer.contact.title')}</h3>
          <p>{t('footer.contact.address')}</p>
          <ul className="contact-info">
            <li><i className="fas fa-phone"></i> {t('footer.contact.phone')}</li>
            <li><i className="fas fa-envelope"></i> {t('footer.contact.email')}</li>
          </ul>
          <div className="social-links">
            <a href="https://facebook.com/anchor-management" target="_blank" rel="noopener noreferrer" aria-label="Facebook">📘</a>
            <a href="https://twitter.com/anchor-management" target="_blank" rel="noopener noreferrer" aria-label="Twitter">🐦</a>
            <a href="https://instagram.com/anchor-management" target="_blank" rel="noopener noreferrer" aria-label="Instagram">📸</a>
          </div>
        </div>

        {/* Newsletter */}
        <div className="footer-section">
          <h3>{t('footer.newsletter.title')}</h3>
          <p>{t('footer.newsletter.description')}</p>
          <form className="newsletter-form">
            <input 
              type="email" 
              placeholder={t('footer.newsletter.placeholder')}
              required 
            />
            <button type="submit">{t('footer.newsletter.subscribe')}</button>
          </form>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Anchor Management. {t('footer.copyright')}</p>
        <p>{t('footer.designedBy')}</p>
        <p>{t('footer.photosBy')}</p>
        <p style={{ fontSize: '0.95rem', marginTop: '0.5rem' }}>
          <a href="/privacy-policy" style={{ color: '#4a90e2', textDecoration: 'underline' }}>{t('footer.privacyPolicy')}</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer; 